import React from "react";
import { components, MenuProps } from "react-select";
import { QueryItem } from "../@types";

const AutosuggestMenu = (props: MenuProps<QueryItem, true>) => (
  <components.Menu
    {...props}
    innerProps={{
      ...props.innerProps,
      onMouseLeave: props.selectProps.onMenuMouseLeave,
      onMouseEnter: props.selectProps.onMenuMouseEnter,
      onMouseOverCapture: props.selectProps.onMenuMouseEnter
    }}
  >
    {props.children}
  </components.Menu>
);

export default AutosuggestMenu;
